import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  calculateDeviation,
  convertMinutesToHours,
  hasDeviationWarning,
  hasHighHoursWarning,
} from '@/utils/durationHelper';

type DurationWarningsProps = {
  confirmedDuration: number;
  originalDuration: number | null;
};

export function DurationWarnings({ confirmedDuration, originalDuration }: DurationWarningsProps) {
  const { t } = useTranslation();
  const hours = convertMinutesToHours(confirmedDuration);
  const deviation = calculateDeviation(originalDuration, confirmedDuration);
  const originalHours = originalDuration ? convertMinutesToHours(originalDuration) : null;

  const showHighHours = hasHighHoursWarning(confirmedDuration);
  const showDeviation = hasDeviationWarning(originalDuration, confirmedDuration);

  return (
    <>
      {showDeviation && originalDuration && (
        <Alert
          type='warning'
          message={t('common:durationDeviationWarningShort')}
          description={t('common:durationDeviationWarning', {
            deviation,
            original: originalDuration,
            originalHours,
            confirmed: confirmedDuration,
            confirmedHours: hours,
          })}
          showIcon
        />
      )}
      {showHighHours && (
        <Alert
          type='info'
          message={t('common:confirmHoursWarning', { hours: hours.toFixed(2) })}
          showIcon
        />
      )}
    </>
  );
}
